import React from 'react';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useRoles from '../../../hooks/useRoles';
import useSetupNavigation from '../useSetupNavigation';
import { useConnect } from '../../../../hooks/@lore/query-connect';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.EDUCATOR_VALUE_YES);

  const roles = useConnect('role.find', {
    where: {
      eager: {
        $where: {
          userId: user.id
        }
      }
    },
    pagination: {
      page: 1,
      pageSize: 100,
      order: 'createdAt asc'
    }
  });

  const { isClassroomTeacher } = useRoles();

  if (roles.state === PayloadStates.FETCHING) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Educator Value</title>
        </Helmet>
        <Loader />
      </ParentLayout>
    );
  }

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Educator Value</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.SCHOOL)}
        onNext={() => isClassroomTeacher ? history.push(Urls.TEACHING) : history.push(Urls.PARTNER_INTENT)}
        onSkip={() => isClassroomTeacher ? history.push(Urls.TEACHING) : history.push(Urls.PARTNER_INTENT)}
      />
    </ParentLayout>
  );
};
